import { useMemo } from 'react'
import { type CrossClientQueryResult } from '../../../../models/CrossClient'
import { useAppSelector } from '../../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../../store/auth/authSlice'
import { selectCrossClientClients, selectCrossClientLookedUpClientIds, selectCrossClientTeammates } from '../../../../store/crossClient/crossClientResults'
import { getOwnerLabel } from '../../utils'
import { toClientView, type CcqClientView } from './ccqResultView'
import { useCcqRun } from './useCcqRun'

export const useCcqClientView = (result: CrossClientQueryResult): CcqClientView => {
  const { clauses } = useCcqRun()
  const clients = useAppSelector(selectCrossClientClients)
  const teammates = useAppSelector(selectCrossClientTeammates)
  const currentUser = useAppSelector(selectSafeAuthenticatedUser)
  const client = clients[result.clientId]
  return useMemo(
    () => toClientView(result, clauses, client, getOwnerLabel(currentUser, teammates, client?.owner?.ownerId ?? null)),
    [result, clauses, client, currentUser, teammates],
  )
}

export const useCcqClientsReady = (results: CrossClientQueryResult[]): boolean => {
  const clients = useAppSelector(selectCrossClientClients)
  const lookedUp = useAppSelector(selectCrossClientLookedUpClientIds)
  return results.every((result) => clients[result.clientId] !== undefined || lookedUp[result.clientId] === true)
}
